import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgDirectionChevronDown32 = ({
  title,
  titleId,
  ...props
}: SVGProps<SVGSVGElement> & SVGRProps, ref: Ref<SVGSVGElement>) => <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} aria-labelledby={titleId} {...props}>{title ? <title id={titleId}>{title}</title> : null}<path d="M1.3335 8C8.5735 8.75333 15.7535 18.8 16.0002 24C16.2402 18.8 23.4268 8.75333 30.6668 8" stroke="currentColor" strokeWidth={1.4} /></svg>;
const ForwardRef = forwardRef(SvgDirectionChevronDown32);
export default ForwardRef;